import countryCodes from '../lib/country-codes'

const whitelistedCountries = [
  'Ghana',
  'Nigeria',
  'United States',
  'South Africa',
  'Kenya',
  'Rwanda',
  'Ethiopia',
]
const ccs = Object.keys(countryCodes)
  .filter((v) => whitelistedCountries.indexOf(countryCodes[v].name) > -1)
  .map((k) => countryCodes[k])

const initialState = { countryCode: '233', phoneNumber: '' }

// Doesn't do validation
export default function PhoneInput({ onChange, value = initialState }) {
  return (
    <div className="input-group">
      <select
        name="countryCode"
        id="contry-code"
        className="form-select"
        value={value.countryCode}
        onChange={(v) => onChange({ ...value, countryCode: v.target.value })}
      >
        {ccs.map((cc) => {
          return (
            <option key={cc.code} value={cc.dialCode}>
              {cc.emoji} {cc.name}
            </option>
          )
        })}
      </select>
      <input
        type="text"
        className="form-control"
        placeholder="Contact phone number"
        style={{ flex: '3 1 auto' }}
        value={value.phoneNumber}
        onChange={(v) => onChange({ ...value, phoneNumber: v.target.value })}
      />
    </div>
  )
}
